import { DataUpdateAPI } from '../../../api/bussched/DataUpdateAPI';

export class DataUpdateCommand {
    constructor() {
        this.dataUpdateApi = new DataUpdateAPI();
    }

    list(edition, successCallback, errorCallback) {
        const apiResult = this.dataUpdateApi.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as atualizações de dados");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/DataUpdateCommand.js